const getters = {
  isAuthenticated: state => state.user.isAuthenticated,

}
export default getters
